import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-program-kpi',
  templateUrl: 'program-kpi.html',
})
export class ProgramKpiPage {

  @ViewChild('myTable') table: any;


  data: any[] = [
    {
      skpi: 'SKPI1',
      skpi_desc: 'Enrolment Completeness:  How efficiently do we gather all the required information to complete the patient enrolment process?',
      target: 90,
      overall: null,
      kpi_ops: 'Enrolment Form Received TO First Outgoing Call',
      achieved: 93,
      days: 1,
      jan: null,
      feb: null,
      mar: null,
      apr: null,
      may: null,
      jun: null,
      jul: null,
      aug: null,
      sep: null,
      oct: null,
      nov: null,
      dec: null
    },
    {
      skpi: 'SKPI1',
      skpi_desc: 'Enrolment Completeness:  How efficiently do we gather all the required information to complete the patient enrolment process?',
      target: 90,
      overall: null,
      kpi_ops: 'Enrolment Complete TO Welcome Package Sent',
      achieved: 90,
      days: 2,
      jan: null,
      feb: null,
      mar: null,
      apr: null,
      may: null,
      jun: null,
      jul: null,
      aug: null,
      sep: null,
      oct: null,
      nov: null,
      dec: null
    },
    {
      skpi: 'SKPI2',
      skpi_desc: 'Payer Decision:  How quickly do we gather all the required information and send to Payer to complete the reimbursement process?',
      target: 94,
      overall: null,
      kpi_ops: 'Enrolment complete TO First Call to Payer',
      achieved: 90,
      days: 1,
      jan: null,
      feb: null,
      mar: null,
      apr: null,
      may: null,
      jun: null,
      jul: null,
      aug: null,
      sep: null,
      oct: null,
      nov: null,
      dec: null
    },
    {
      skpi: 'SKPI2',
      skpi_desc: 'Payer Decision:  How quickly do we gather all the required information and send to Payer to complete the reimbursement process?',
      target: 94,
      overall: null,
      kpi_ops: 'First Call to Payer TO SA submitted to MD',
      achieved: 95,
      days: 1,
      jan: null,
      feb: null,
      mar: null,
      apr: null,
      may: null,
      jun: null,
      jul: null,
      aug: null,
      sep: null,
      oct: null,
      nov: null,
      dec: null
    },
    {
      skpi: 'SKPI2',
      skpi_desc: 'Payer Decision:  How quickly do we gather all the required information and send to Payer to complete the reimbursement process?',
      target: 94,
      overall: null,
      kpi_ops: 'SA Received from MD TO SA Sent to PT (if applicable)',
      achieved: 95,
      days: 1,
      jan: null,
      feb: null,
      mar: null,
      apr: null,
      may: null,
      jun: null,
      jul: null,
      aug: null,
      sep: null,
      oct: null,
      nov: null,
      dec: null
    },
    {
      skpi: 'SKPI2',
      skpi_desc: 'Payer Decision:  How quickly do we gather all the required information and send to Payer to complete the reimbursement process?',
      target: 94,
      overall: null,
      kpi_ops: 'SA Received from PT/MD TO SA Sent to Payer',
      achieved: 95,
      days: 1,
      jan: null,
      feb: null,
      mar: null,
      apr: null,
      may: null,
      jun: null,
      jul: null,
      aug: null,
      sep: null,
      oct: null,
      nov: null,
      dec: null
    },
    {
      skpi: 'SKPI3',skpi_desc: 'Drug Orders and Delivery: How effective are we at coordinating the drug order and delivery? (Network and HCP Pharmacy)',
      target: 90,
      overall: null,
      kpi_ops: 'Reimbursement Approved TO Pharmacy Set-Up',
      achieved: 90,
      days: 1,
      jan: null,
      feb: null,
      mar: null,
      apr: null,
      may: null,
      jun: null,
      jul: null,
      aug: null,
      sep: null,
      oct: null,
      nov: null,
      dec: null
    },
    {
      skpi: 'SKPI4',
      skpi_desc: 'Reimbursement Ongoing: How effective are we at supporting continuation of coverage?',
      target: 95,
      overall: null,
      kpi_ops: 'SA Expiry Renewal Schedule Date (TBD) TO SA Sent to MD',
      achieved: 95,
      days: 1,
      jan: null,
      feb: null,
      mar: null,
      apr: null,
      may: null,
      jun: null,
      jul: null,
      aug: null,
      sep: null,
      oct: null,
      nov: null,
      dec: null
    },
  ]

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProgramKpiPage');
  }

  toggleExpandGroup(group) {
    console.log('Toggled Expand Group!', group);
    this.table.groupHeader.toggleExpandGroup(group);
  }

  onDetailToggle(event) {
    console.log('Detail Toggled', event);
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-kpi/program-kpi.ts